import React from 'react';

import styles from './user-info-menu-content-header.module.css';
import { isAnonymousUser } from '../../../utils';
import { UserInfoMenuContentProfile } from '../user-info-menu-content-profile/user-info-menu-content-profile';
import { useAuthorizeContext } from '../../../shell';
import { useDisplayWallet } from '../../../hooks/use-display-wallet';
import { MenuLink } from '../../menu-link/menu-link';
import VerificationPassedIcon from '../icons/verification-status.component.svg';

export const UserInfoMenuContentHeader: React.FC = () => {
    const { user, verification } = useAuthorizeContext();
    const { shouldDisplayWallet, walletLink, walletText, walletBalance } = useDisplayWallet();

    return (
        <div className={styles.userInfoMenuContentHeader}>
            <div className={styles.userInfoMenuContentHeaderProfile}>
                <div className={styles.userInfoMenuContentHeaderVerification}>
                    <span className={styles.userInfoMenuContentHeaderProfileText}>Личный кабинет</span>
                    {verification?.isAlreadyPassedM2ProVerification && (
                        <span className={styles.userInfoMenuVerificationIcon}>
                            <VerificationPassedIcon />
                        </span>
                    )}
                </div>
                {user && !isAnonymousUser(user.username) && <UserInfoMenuContentProfile user={user} />}
            </div>
            {shouldDisplayWallet && (
                <MenuLink
                    dataTest="user-wallet-link"
                    key="wallet"
                    item={{
                        icon: 'm2-wallet',
                        id: 'wallet',
                        displayName: walletBalance ? `Баланс: ${walletText}` : 'Баланс',
                        path: walletLink,
                    }}
                    isOpenByDefault={false}
                />
            )}
        </div>
    );
};
